import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'shipment-handover-report',
	components: {
		Paginate,
		DatePicker,
		download,
		JsonExcel,
		Pagination,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			listMerchantData: [],
			merchantnameFlt: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalRows:0,
			// currentPage: 0,
			listShipmentHandoverData: [],
			// perPage: 10,
			// pageno: 0,
			// pageCount: 0,
			warehousename: '',
			couriername: '',
			fromdate: '',
			todate: '',
			listShipmentHandoverDatacsv: [],
			listwarehouseidData: [],
			listshippingcompanyData: [],
			csvFields: [],
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			userid: '',
			isLoadingforxls: false,
			recordLimit: 0,
			limitExeed: false,
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			mid: '',
			searchbtoborder: '',
			manifestid: ''
		}
	},
	computed: {},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY');
		}
	},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmailk = userdetail.email;
		this.userid = userdetail.userid;
		this.reportname = this.$t('shipmentHandoverReport.shipmentHandoverReportFile')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		//	console.log(this.user_type);
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getshippingData();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				//			this.getshippingData();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();


				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			this.getshippingData()
		  });
	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantnameFlt = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getShipmentHandoverReportDataForXls(3)
			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 				// this.getshippingData();
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getMerchantList() {
			this.listMerchantData1 = []
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.merchantPlaceholder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.item = {}
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getshippingData();
		// 				this.getMerchantList();

		// 				//this.getShipmentHandoverReportData();
		// 			}

		// 		}
		// 	}
		// 	this.listOrderReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getShipmentHandoverReportData();
		// 			this.getshippingData()
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getshippingData() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			})
			axios({

				method: 'POST',
				'url': apiUrl.api_url + 'shippingDetails',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					// console.log("abcd");

					this.listshippingcompanyData = result.data.data
				}, error => {
					console.error(error)
				})
		},
		getShipmentHandoverReportDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getShipmentHandoverReportData(2);
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		//to get Shipment Report list
		getShipmentHandoverReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.pageCount = 0;
				this.listOrderReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.pageCount = 0;
				this.listOrderReportData = [];
				return false;
			}
			this.isLoading = true;
			if (this.fromdate) {
				fr_date = this.dateFormat1(this.fromdate);
			}
			if (this.todate) {
				to_date = this.dateFormat2(this.todate);
			}
			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: fr_date,
				todate: to_date,
				shippingcompany: this.couriername,
				csvData: csvCheck,
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
				merchantid: this.merchantnameFlt,
				searchbtoborder: this.searchbtoborder
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			if (this.clientid != '') {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'shipmentReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						// console.log(result);
						if (csvCheck == 1) {
							if (result.data.data.length > 0) {
								this.show = true;
								this.download = false;
								this.listReportDatacsv = [];
								this.csvFields = {
									'orderid': this.$t('common.orderNumber'),
									'boxid': this.$t('common.boxId'),
									'shippingid': this.$t('shipmentHandoverReport.shipId'),
									'shippingcompany': this.$t('common.courierName'),
									'awbno': this.$t('shipmentHandoverReport.table.columns.awb'),
									'shipval': this.$t('shipmentHandoverReport.shipValue'),
									'shipmentweight': this.$t('common.shipmentWeight'),
									'shipmentvolumetricweight': this.$t('shipmentHandoverReport.table.columns.shipmentVolumetricWeight'),
									'dispatcheddatetime': this.$t('shipmentHandoverReport.table.columns.handoverDateandTime'),
									'handedby': this.$t('shipmentHandoverReport.table.columns.dispatchedBy'),
									'takenby': this.$t('shipmentHandoverReport.table.columns.dispatchedTo'),
									'merchantname': this.$t('common.merchantName'),
									'manifestid': this.$t('common.manifestid'),


								};
								var dateFilter = [];
								var skipFilter = ['warehouseid', 'warehousename', 'merchantid', 'btoborder'];
								this.listShipmentHandoverDatacsv = result.data.data;
								// for (var j = 0; j < this.listShipmentHandoverDatacsv.length; j++) {
								// 	for (var i = 0; i < this.listMerchantData.length; i++) {
								// 		if (this.listMerchantData[i].merchantid == this.listShipmentHandoverDatacsv[j].merchantid) {
								// 			this.listShipmentHandoverDatacsv[j].merchantname = this.listMerchantData[i].merchantname
								// 		} else {
								// 			this.listShipmentHandoverDatacsv[j].merchantname = '';
								// 		}
								// 	}
								// }
								csvHelper.data.jsonToCSV(this.$t('shipmentHandoverReport.shipmentHandoverReportFile'), this.listShipmentHandoverDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

								// this.jsonToCSV('ShipmentHandoverReport', this.listShipmentHandoverDatacsv, this.csvFields, dateFilter, skipFilter);
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}
						} else {
							this.listShipmentHandoverData = result.data.data

							for (var j = 0; j < this.listShipmentHandoverData.length; j++) {
								for (var i = 0; i < this.listMerchantData.length; i++) {
									if (this.listMerchantData[i].merchantid == this.listShipmentHandoverData[j].merchantid) {
										this.listShipmentHandoverData[j].merchantname = this.listMerchantData[i].merchantname
									}
								}
							}
							if (result.data.errorCode == -1) {
								this.resultCount = 0
							} else {
								this.totalRows = result.data.count
								this.resultCount = result.data.count
								if (Number(this.totalRows) > Number(this.recordLimit)) {
									this.limitExeed = true
								}
								if (this.totalRows <= this.pageLimit) {
									this.totalPage = 1;
								} else {
									this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
								}
							}
						}

						this.isLoading = false;
					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');
			}

		},
		getShipmentHandoverReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate) {
				fr_date = this.dateFormat1(this.fromdate);
			}
			if (this.todate) {
				to_date = this.dateFormat2(this.todate);
			}
			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: fr_date,
				todate: to_date,
				shippingcompany: this.couriername,
				csvData: csvCheck,
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
				merchantid: this.merchantnameFlt,
				searchbtoborder: this.searchbtoborder,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			if (this.clientid != '') {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'shipmentReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						// console.log(result);
						if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls[this.$t('common.orderNumber')]='orderid';
								this.csvFieldsForXls[this.$t('common.boxId')]='boxid';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.shipId')]='shippingid';
								this.csvFieldsForXls[this.$t('common.courierName')]='shippingcompany';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.table.columns.awb')]='awbno';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.shipValue')]='shipval';
								this.csvFieldsForXls[this.$t('common.shipmentWeight')]='shipmentweight';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.table.columns.shipmentVolumetricWeight')]='shipmentvolumetricweight';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.table.columns.handoverDateandTime')]='dispatcheddatetime';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.table.columns.dispatchedBy')]='handedby';
								this.csvFieldsForXls[this.$t('shipmentHandoverReport.table.columns.dispatchedTo')]='takenby';
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname';
								this.csvFieldsForXls[this.$t('common.manifestid')]='manifestid';


								this.listReportDataforxls = result.data.data;
								// for (var j = 0; j < this.listReportDataforxls.length; j++) {
								// 	for (var i = 0; i < this.listMerchantData.length; i++) {
								// 		if (this.listMerchantData[i].merchantid == this.listReportDataforxls[j].merchantid) {
								// 			this.listReportDataforxls[j].merchantname = this.listMerchantData[i].merchantname
								// 		}
								// 	}
								// }
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}
						}
					}, error => {
						console.error(error)
					})
			} else {
				this.ClientErr = this.$t('common.clientError');
			}

		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getShipmentHandoverReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getShipmentHandoverReportData()
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		//to reset search form
		resetSearchForm() {
			this.searchbtoborder = ''
			this.show = false;
			this.download = true;
			this.fromdate = '';
			this.todate = '';
			this.warehousename = '';
			this.couriername = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.merchantnameFlt = '';
			this.item = {}
			this.listShipmentHandoverData = [];
			this.searchFlag = false;

			// this.getShipmentHandoverReportData();
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/shipmentHandoverReport/shipmentHandoverReport.component.js